<template>
  <a-coupon :bordered="false">
    <app-warp title='微信卡包'>
      <template #app-content>
        <div class="p-10 s_bf">
          <div class="app-user-coupon" :style="{'background':form.cover_type == 0 ? form.color : !form.background ? form.color:('url('+form.background+') center center/cover no-repeat')}">
            <div class="app-coupon-heard">
              <div class="left">
                <img style="border:1px solid #fff;object-fit:cover" :src="form.logo?form.logo:require('@/assets/images/normal.png')" alt="" />
                <div>
                  <span class="app-coupon-name" style="text-shadow: 1px 1px 3px #666;">一物一码数据服务</span>
                  <div class="app-coupon-leveName" style="text-shadow: 1px 1px 3px #666;">{{form.vip_name || '会员卡标题'}}</div>
                </div>
              </div>
              <div class="right">
                <img src="@/assets/images/user/erweima-3@2x.png" alt="">
              </div>
            </div>
            <div class="app-coupon-foot" style="text-shadow: 1px 1px 3px #666;">
              0000 0000 0001
            </div>
          </div>
        </div>
        <div class="s_bf">
          <div class="app-user-router">
            <div class="app-router-head">
              <div class="app-router-head-item">
                <p>积分</p>
                <a class="fz-16" href="javascript:;">10000</a>
              </div>
              <div class="app-router-head-item" v-if='form.coupon_show'>
                <p>优惠券</p>
                <a class="fz-16" href="javascript:;">查看</a>
              </div>
              <div class="app-router-head-item" v-if='form.level_show'>
                <p>等级</p>
                <a class="fz-16" href="javascript:;">青铜</a>
              </div>
            </div>
            <div class="p-l-20 p-r-20">
              <div class="app-user-route">
                <div class='app-user-route-item' v-for='item in form.entry_list' :key='item'>
                  <div class="app-user-route-item-title">{{item.name || '入口名称'}}</div>
                  <div class="app-user-route-item-icon">
                    <span class="s_c999 p-r-10">{{item.guide}}</span>
                    <RightOutlined />
                  </div>
                </div>
                <div class='app-user-route-item'>
                  <div class="app-user-route-item-title">会员卡详情</div>
                  <div class="app-user-route-item-icon">
                    <RightOutlined />
                  </div>
                </div>
                <div class='app-user-route-item'>
                  <div class="app-user-route-item-title">公众号</div>
                  <div class="app-user-route-item-icon">
                    <RightOutlined />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #app-sider>
        <div class="m-l-50 s_bf7 p-t-25 p-b-25">
          <a-form :model="form" ref='ruleForm' :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-item label="开通【微信卡包】" help='若开启了微信卡包，公众号必须关联小程序，否则无法跳转到小程序。'>
              <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_open_wechat_card" @change="onChange" checked-children="开启" un-checked-children="关闭" />
            </a-form-item>

        
            <div v-if='form.is_open_wechat_card'>
                    <a-form-item label="商户名称" name='merchant_name' :rules="[{ required: true, message: '请输入商户名称' },{ max: 12, message: '商户名称不超过12个字符' }]">
              <a-input v-model:value="form.merchant_name"  :disabled="disabledMerchant_name" placeholder="请输入商户名称" :maxlength='12' :suffix="form.merchant_name.length+'/12'" allowClear style="width:200px" />
            </a-form-item>  
              <a-form-item label="会员卡LOGO" name='logo'>
                <div class="width-107 height-107 s_ovber">
                  <wxMaterial :image="form.logo" :max="1" v-on:handlechoose="(data)=>{form.logo=data.imageUrl;form.logo_media_id=data.data.media_id}" v-on:handledel="form.logo_media_id='';form.logo=''" />
                </div>
              </a-form-item>
              <a-form-item label="会员卡标题" name='vip_name' help='建议会员卡标题包含商户名或服务内容，如腾讯会员黄钻尊享卡'>
                <a-input v-model:value="form.vip_name" :maxlength='9' :suffix="form.vip_name.length+'/9'" allowClear style="width:200px" />
              </a-form-item>
              <a-form-item label="卡券封面" name='cover_type'>
                <a-radio-group v-model:value="form.cover_type">
                  <a-radio :value="0"> 颜色 </a-radio>
                  <a-radio :value="1"> 图片 </a-radio>
                </a-radio-group>

                <br />
                <div v-if="form.cover_type==0">
                  <a-popover>
                    <template #content>
                      <div class="width-150 clearfix">
                        <p class="s_shou width-20 height-20 m-l-5 m-r-5 m-b-5 fl" :style='"background-color:"+item.color' v-for='item in colorList' :key='item' @click='form.color = item.color;form.color_name = item.name;'></p>
                      </div>
                    </template>
                    <div class="width-130 height-30 s_bor_cd9 bor-rad-5 s_flex_bian_c m-t-5 p-l-5 p-r-5">
                      <div class="width-32 height-22" :style='"background-color:"+form.color'></div>
                      <CaretDownOutlined style="color:#666" />
                    </div>
                  </a-popover>
                </div>
                <div class="img_map" v-if="form.cover_type==1">
                  <div class="width-107 height-107 s_ovber">
                    <wxMaterial :image="form.background" :max="1" v-on:handlechoose="(data)=>{form.background=data.imageUrl;form.background_media_id=data.data.media_id}" v-on:handledel="form.background_media_id='';form.background=''" />
                  </div>
                  <span class="s_c999">设计背景时需严格执行：尺寸1000*600像素，图片大小小于1M，格式jpg、png、jpeg</span>
                </div>
              </a-form-item>
              <a-form-item label="特权说明" name='privilege_text' :rules="[{ required: true, message: '请输入特权说明' },{ max: 300, message: '特权说明不超过300个字符' }]">
                <a-textarea v-model:value="form.privilege_text" showCount :maxlength="300" />
              </a-form-item>
              <a-form-item label="使用须知" name='instructions_text' help='微信会员卡的使用须知，为方便用户使用，建议填写'>
                <a-textarea v-model:value="form.instructions_text" showCount :maxlength="300" />
              </a-form-item>
              <a-form-item label="功能入口">
                <div class="s_bf p-15 p-t-10">
                  <div class="s_flex_ali">
                    <p class="width-80">优惠券</p>
                    <a-radio-group v-model:value="form.coupon_show">
                      <a-radio :value="1"> 显示 </a-radio>
                      <a-radio :value="0"> 不显示 </a-radio>
                    </a-radio-group>
                  </div>
                  <div class="s_flex_ali" v-if='form.coupon_show'>
                    <p class="width-80">点击跳转</p>
                    <a-radio-group v-model:value="form.coupon_url_type" @change='form.coupon_url=""'>
                      <a-radio :value="1"> 网页链接 </a-radio>
                      <a-radio :value="2"> 小程序 </a-radio>
                    </a-radio-group>
                  </div>
                  <div class="s_flex_ali" v-if='form.coupon_show'>
                    <p class="width-80">跳转链接</p>
                    <a-input :class="form.coupon_url_type == 2 ? 'width70':'width85'" v-model:value="form.coupon_url" allowClear style="width:200px" />
                    <a-button class="m-l-10" type="primary" v-if='form.coupon_url_type ==2' @click='linkVisible = true;linkType = "coupon"'>选择</a-button>
                  </div>
                </div>
                <div class="s_bf p-15 p-t-10 m-t-10">
                  <div class="s_flex_ali">
                    <p class="width-80">会员等级</p>
                    <a-radio-group v-model:value="form.level_show">
                      <a-radio :value="1"> 显示 </a-radio>
                      <a-radio :value="0"> 不显示 </a-radio>
                    </a-radio-group>
                  </div>
                  <div class="s_flex_ali" v-if='form.level_show'>
                    <p class="width-80">点击跳转</p>
                    <a-radio-group v-model:value="form.level_url_type" @change='form.level_url=""'>
                      <a-radio :value="1"> 网页链接 </a-radio>
                      <a-radio :value="2"> 小程序 </a-radio>
                    </a-radio-group>
                  </div>
                  <div class="s_flex_ali" v-if='form.level_show'>
                    <p class="width-80">跳转链接</p>
                    <a-input :class="form.level_url_type == 2 ? 'width70':'width85'" v-model:value="form.level_url" allowClear style="width:200px" />
                    <a-button class="m-l-10" type="primary" v-if='form.level_url_type == 2' @click='linkVisible = true;linkType = "level"'>选择</a-button>
                  </div>
                </div>
              </a-form-item>
              <template v-for='(item,index) in form.entry_list' :key='index'>
                <a-form-item :label="'自定义入口'+(index+1)" name=''>
                  <div class="s_flex_bian s_bf p-15 p-t-10 m-t-10">
                    <div class="width90">
                      <div class="s_flex_ali m-b-15">
                        <p class="width-80">入口名称</p>
                        <a-input class="width85" v-model:value="item.name" :maxlength='5' :suffix="item.name.length+'/5'" allowClear style="width:200px" />
                      </div>
                      <div class="s_flex_ali m-b-15">
                        <p class="width-80">引导语</p>
                        <a-input class="width85" v-model:value="item.guide" :maxlength='6' :suffix="item.guide.length+'/6'" allowClear style="width:200px" />
                      </div>
                      <div class="s_flex_ali m-b-15">
                        <p class="width-80">点击跳转</p>
                        <a-radio-group v-model:value="item.url_type" @change='item.url=""'>
                          <a-radio :value="1"> 网页链接 </a-radio>
                          <a-radio :value="2"> 小程序 </a-radio>
                        </a-radio-group>
                      </div>
                      <div class="s_flex_ali">
                        <p class="width-80">跳转链接</p>
                        <a-input :class="item.url_type == 2 ? 'width70':'width85'" v-model:value="item.url" allowClear style="width:200px" />
                        <a-button class="m-l-10" type="primary" v-if='item.url_type == 2' @click='linkVisible = true;linkType = "list";linkIndex = index'>选择</a-button>
                      </div>
                    </div>
                    <a-button type="link" @click='form.entry_list.splice(index,1)'>删除</a-button>
                  </div>
                </a-form-item>
              </template>
              <a-form-item :wrapper-col="{ span: 14, offset: 5 }" help='可配置图文消息、货架、网页链接,用户可查看详情或领取更多卡券。' :hidden='form.entry_list.length == 4'>
                <a-button type="primary" @click='addEntry'>添加自定义入口</a-button>
              </a-form-item>
            </div>
            <a-form-item :wrapper-col="{ span: 14, offset: 5 }" class="m-t-30">
              <a-button type="primary" v-has:setMemberWechatCard="onSubmit"> 保存 </a-button>
            </a-form-item>
          </a-form>
        </div>
      </template>
    </app-warp>
  </a-coupon>
  <!-- 链接选择 -->
  <a-modal :keyboard="false" title="链接" centered v-model:visible="linkVisible" :footer="null" destroyOnClose>
    <selectLink v-on:select="select" />
  </a-modal>
</template>
<script>
import { reactive, toRef, toRefs, onMounted, ref, inject } from "vue";
import { getMemberWechat, setMemberWechat } from "@/api/member";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import { RightOutlined, CaretDownOutlined } from "@ant-design/icons-vue";
import store from "@/store";
import selectLink from "./components/selectLink";
// 初始化默认筛选项数值
let defForm = {
  is_open_wechat_card: 1,
  logo: "",
  logo_media_id: "",
  vip_name: "",
  cover_type: 0,
  color: "#63b359",
  color_name: "Color010",
  background: "",
  background_media_id: "",
  coupon_show: 1,
  coupon_url_type: 1,
  coupon_url: "",
  level_show: 1,
  level_url_type: 1,
  level_url: "",
  entry_list: [],
  merchant_name: "", //商户名称
  privilege_text: "", //特权说明
  instructions_text: "", //使用须知
};
export default {
  components: { RightOutlined, CaretDownOutlined, selectLink },
  setup(props) {
    let cover_type = async () => {
      if (form.value.cover_type == 1 && form.value.background == "") {
        return Promise.reject("请上传卡券封面图片！");
      } else {
        return Promise.resolve();
      }
    };
    const form = ref({ ...defForm });
    const state = reactive({
      disabledMerchant_name:false,
      linkVisible: false,
      linkType: "",
      linkIndex: 0,
      info: store.state.user.info,
      colorList: [
        { color: "#63b359", name: "Color010" },
        { color: "#2c9f67", name: "Color020" },
        { color: "#509fc9", name: "Color030" },
        { color: "#5885cf", name: "Color040" },
        { color: "#9062c0", name: "Color050" },
        { color: "#d09a45", name: "Color060" },
        { color: "#e4b138", name: "Color070" },
        { color: "#ee903c", name: "Color080" },
        { color: "#dd6549", name: "Color090" },
        { color: "#cc463d", name: "Color100" },
      ],
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      rules: {
        logo: [{ required: true, message: "请上传会员卡LOGO" }],
        vip_name: [{ required: true, message: "请输入会员卡标题" }],
        cover_type: [{ required: true, validator: cover_type }],
      },
    });
    const $router = inject("$router");
    const $route = inject("$route");
    //添加入口
    const addEntry = () => {
      if (form.value.entry_list.length == 4) {
        message.error("最多只能添加4个入口！");
        return;
      }
      form.value.entry_list.push({ name: "", guide: "", url_type: 1, url: "" });
    };
    //选择链接
    const select = (data) => {
      if (state.linkType == "coupon") {
        form.value.coupon_url = data;
      }
      if (state.linkType == "level") {
        form.value.level_url = data;
      }
      if (state.linkType == "list") {
        form.value.entry_list[state.linkIndex].url = data;
      }
      state.linkVisible = false;
    };
    //获取详情
    const getData = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res = await getMemberWechat().then((res) => res.data);
      if (res.data.content) {
        console.log(res.data.content);
        form.value = JSON.parse(res.data.content);
        if(!form.value.merchant_name){
          form.value['merchant_name']=''
        }else{
          state.disabledMerchant_name=true
        }
      }
      setTimeout(hide);
    };
    // 保存
    const ruleForm = ref();
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async (e) => {
          const hide = message.loading("正在加载中...", 0);
          form.value.is_open_wechat_card = form.value.is_open_wechat_card
            ? 1
            : 0;
          let res = await setMemberWechat({
            content: JSON.stringify(form.value),
          }).then((res) => res.data);
          message.success(res.msg);
          setTimeout(hide);
        })
        .catch((error) => {});
    };
    onMounted(() => {
      getData();
    });
    return {
      ...toRefs(state),
      form,
      ruleForm,
      onSubmit,
      addEntry,
      select,
    };
  },
};
</script>
<style lang="less" scoped>
@import url("@/style/app-warp/app-warp.less");

.ant-checkbox-wrapper {
  width: 500px;
}

.normal_map {
  ul {
    display: flex;
    flex-wrap: wrap;

    li {
      margin-right: 10px;
      margin-bottom: 10px;

      label {
        width: 57px;
        height: 57px;
        display: block;
        border: 1px solid transparent;
      }

      input:checked ~ label {
        border: 1px solid #05486a;
      }
    }
  }
}
</style>